import {
  ActivityFilterKey
} from '@gripp/shared-logic';
import { ActivitySearchInput, FilterType } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { Outlet } from 'react-router-dom';
import { CurrentIssueContextProvider } from '../../issues/issueContext';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { ErrorBoundary } from '../../shared/logging/errorBoundary';
import { ActivitiesProps, ActivityList } from './activityList';

export const ActivityFold = (props: ActivitiesProps) => {
  const filterKey = props.assetId
    ? ActivityFilterKey.AssetActivity
    : ActivityFilterKey.Activity;

  return (
    <CurrentIssueContextProvider>
      <View style={styles.filtersContainer}>
        <View style={styles.activitySearchContainer}>
          <ActivitySearchInput filterKey={filterKey} />
        </View>
        <FilterBar
          filterButtonTypes={[
            FilterType.ACTIVITYGROUPS,
            FilterType.ACTIVITYTYPES,
            FilterType.ACTIVITYLABELS,
            FilterType.ACTIVITYDATE,
          ]}
          filterKey={filterKey}
        />
      </View>
      <View style={styles.container}>
        <View style={styles.listContainer}>
          <ActivityList
            onDataLoaded={props.onDataLoaded}
            {...props}
          />
        </View>
        <View style={styles.gutter} />
        <ErrorBoundary inline>
          <Outlet />
        </ErrorBoundary>
      </View>
    </CurrentIssueContextProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
  },
  activitySearchContainer: {
    width: 350,
    marginRight: 20,
  },
  listContainer: {
    flex: 1,
    width: '45%',
    overflow: 'hidden',
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
  },
  gutter: {
    width: 24,
  },
});
